import { Component, Input, ElementRef, OnChanges} from '@angular/core';

@Component({
    selector: 'read-more',
    styles: [
        `.max-lines {
            text-overflow: ellipsis;
            word-wrap: break-word;
            overflow: hidden;
            max-height: 54px;
            line-height: 18px;
          }
          .read-more-btn {
            display: block;
          }
          `
    ],
    template: `
        <p *ngIf="isCollapsed" [innerHTML]="text" class="max-lines">
        </p>
        <p *ngIf="!isCollapsed" [innerHTML]="text">
        </p>
            <a class="read-more-btn" *ngIf="textWithoutHtml && textWithoutHtml.length > maxLength" [class.hidden]="hideToggle" (click)="toggleView(); $event.stopPropagation()">Read {{isCollapsed? 'more':'less'}}</a>
    `
})

export class ReadMoreComponent implements OnChanges {
    @Input() text: string;
    @Input() maxLength: number = 100;
    currentText: string;
    hideToggle: boolean = true;
    textWithoutHtml: string;

    public isCollapsed: boolean = true;

    constructor(private elementRef: ElementRef) {

    }
    toggleView() {
        this.isCollapsed = !this.isCollapsed;
        this.determineView();
    }
    determineView() {

        this.textWithoutHtml = this.trimHtml(this.text);

        if (!this.text || this.trimHtml(this.text).length <= this.maxLength) {
            // this.currentText = this.text;
            this.isCollapsed = false;
            this.hideToggle = true;
            return;
        }

        // this.hideToggle = false;
        // if (this.isCollapsed == true) {
        //     this.currentText = this.text.replace(this.textWithoutHtml, this.textWithoutHtml.substring(0, this.maxLength) + "...");
        // } else if(this.isCollapsed == false)  {
        //     this.currentText = this.text;
        // }

    }
    ngOnChanges() {
        this.determineView();
    }

    trimHtml(text: string) {
        return text ? text.replace(/<\/?[^>]+(>|$)/g, "") : text;
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/read-more.component.ts